import request from '@/utils/request'
import qs from 'qs'
const loginPath = '/power'
const workPath = '/portal/prNews'

export function verification(data) {
  return request({
    url: loginPath + '/user/verif',
    method: 'post',
    data: qs.stringify(data)
  })
}
export function login(data) {
  return request({
    url: loginPath + '/user/login',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 移动端登录
export function loginPhone(data) {
  return request({
    url: loginPath + '/user/mobileLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getInfo(token) {
  let data = {
    token: token
  }
  return request({
    url: loginPath + '/user/info',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function logout(data) {
  return request({
    url: loginPath + '/user/logout',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function authMenuButton(data) {
  return request({
    url: loginPath + '/menu/authMenuButton',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getCode(data) {
  return request({
    url: loginPath + '/user/getCode',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function getAunnt(data) {
  return request({
    url: loginPath + '/user/recoverPwd',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取用户授权的第三方应用

export function findPwThirdpartyList(data) {
  return request({
    url: loginPath + '/pwThirdparty/findPwThirdpartyList',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 获取用户授权的第三方应用

export function hopRouting(data) {
  return request({
    url:'/shibboleth'+ loginPath + '/central/user/hopRouting',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function centralViewFile(data) {
  return request({
    url:loginPath + '/central/user/viewFile',
    method: 'post',
    data: qs.stringify(data)
  })
}


export function viewFile(data) {
  return request({
    url:loginPath + '/document/manager/viewFile',
    method: 'post',
    data: qs.stringify(data)
  })
}


export function findPwThirdpartyLists(data) {
  return request({
    url: '/shibboleth/power/central/user/findPwThirdpartyList',
    method: 'post',
    data: qs.stringify(data)
  })
}

/* 分页*/
export function pageNotLogin(data) {
  return request({
    url: workPath+'/pageNotLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 详情
export function getNOtLogin(data) {
  return request({
    url: workPath+'/getNOtLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function listByFlag(data) {
  return request({
    url: loginPath+'/busiClass/listByFlagNotLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 授权校验
export function authUser(data) {
  return request({
    url:'/shibboleth'+ loginPath+'/central/user/auth',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 授权登录
export function authLogin(data) {
  return request({
    url: loginPath+'/user/authLogin',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取session
export function getSession(data) {
  return request({
    url: loginPath+'/user/getSession',
    method: 'post',
    data: qs.stringify(data)
  })
}

//通知公告
export function pageNotLoginWork(data) {
  return request({
    url: workPath+'/pageNotLoginWork',
    method: 'post',
    data: qs.stringify(data)
  })
}

//试点高校
export function schoolList(data) {
  return request({
    url: '/shibboleth/power/central/user/list',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 分页
export function collegepage(data) {
  return request({
      url: '/shibboleth/power/central/user/page',
      method: 'post',
      data: qs.stringify(data)
  })
}

// 易班
export function ybStatistics(data) {
  return request({
      url: '/portal/prNews/ybStatistics',
      method: 'post',
      data: qs.stringify(data)
  })
}

//数据
export function getPrChart(data) {
  return request({
      url: '/portal/prChart/list',
      method: 'post',
      data: qs.stringify(data)
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js